'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_TwoFactorAuthView$$anon$7() {
  this.bGG = null;
  this.bGE = null;
  this.bGF = false;
  this.bGC = null;
  this.bGD = false;
  this.bGH = false;
  this.bGI = false;
  this.bGG = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_TwoFactorAuthView$$anon$7 as $c_Lpresto_TwoFactorAuthView$$anon$7 };
$p = $c_Lpresto_TwoFactorAuthView$$anon$7.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_TwoFactorAuthView$$anon$7;
/** @constructor */
function $h_Lpresto_TwoFactorAuthView$$anon$7() {
}
export { $h_Lpresto_TwoFactorAuthView$$anon$7 as $h_Lpresto_TwoFactorAuthView$$anon$7 };
$h_Lpresto_TwoFactorAuthView$$anon$7.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.ad = (function() {
  return this.bGG;
});
$p.t = (function() {
  if ((!this.bGF)) {
    this.bGE = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("name", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("seed", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.bGF = true;
  }
  return this.bGE;
});
$p.ae = (function() {
  if ((!this.bGD)) {
    this.bGC = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().aD, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().aD, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.bGD = true;
  }
  return this.bGC;
});
$p.w = (function() {
  if ((!this.bGI)) {
    this.bGH = false;
    this.bGI = true;
  }
  return this.bGH;
});
$p.ac = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_TwoFactorAuthView$$anon$7 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_TwoFactorAuthView$$anon$7, "presto.TwoFactorAuthView$$anon$7", ({
  T9: 1,
  a: 1,
  k: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_TwoFactorAuthView$$anon$7 as $d_Lpresto_TwoFactorAuthView$$anon$7 };
//# sourceMappingURL=presto.-Two-Factor-Auth-View$$anon$7.js.map
